module.exports = __webpack_public_path__ + "img/video2.efbdc66c.png";